module.exports = __webpack_public_path__ + "img/556.0b6df540.jpg";